import { render, staticRenderFns } from "./DefaultOrganizationsDetail.vue?vue&type=template&id=31d210ee"
import script from "./DefaultOrganizationsDetail.vue?vue&type=script&lang=js"
export * from "./DefaultOrganizationsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports